// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@conklin/Overrides/Widgets/QuickOrder/QuickOrderActions";
import { xScreen } from "@conklin/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        clear: both;
    `,
};

actionsStyles.addToListButton = {
    variant: "secondary",
    css: css`
        margin-top: 12px;
        width: 100%;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-left: 0;
                `,
                css`
                    margin-left: 0;
                `,
                css`
                    margin-left: 0;
                `,
            ])}
    `,
};

actionsStyles.addAllToCartButton = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

actionsStyles.uploadOrderButton = {
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: block;
                    width: 100%;
                `,
                css`
                    display: block;
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
};

actionsStyles.uploadOrderButtonWrapper = {
    css: css`
        margin-top: 22px;

        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};
